import { Link } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { formatSubscriptionExpiry } from "../utils/userProfile";

import { getMessengerChannelLabel } from "../utils/projectAccess";

const STEPS = [
  {
    id: "subscription",
    title: "Оформите подписку",
    desc: "Выберите тариф по размеру команды.",
    link: "/main/price",
    linkLabel: "Тарифы",
  },
  {
    id: "publish",
    title: "Опубликуйте сценарий",
    desc: "Подготовьте программу и включите публикацию в настройках.",
    link: null,
    linkLabel: null,
  },
  {
    id: "share",
    title: "Разошлите ссылку сотрудникам",
    desc: "Скопируйте групповую ссылку из настроек сценария и отправьте в выбранный мессенджер.",
    link: null,
    linkLabel: null,
  },
];

export default function OnboardingChecklist({
  businessSubscription,
  games,
  preferredMessenger = "telegram",
}) {
  const safeGames = Array.isArray(games) ? games : [];
  const messengerLabel = getMessengerChannelLabel(preferredMessenger);
  const hasSubscription = Boolean(formatSubscriptionExpiry(businessSubscription));
  const hasPublished = safeGames.some((game) => game?.settings?.published);
  const hasShareReady = safeGames.some(
    (game) => game?.settings?.published && game?.settings?.private_access === false,
  );

  const completed = {
    subscription: hasSubscription,
    publish: hasPublished,
    share: hasShareReady,
  };

  const doneCount = Object.values(completed).filter(Boolean).length;
  if (doneCount === STEPS.length) return null;

  return (
    <section className="app-onboarding">
        <div className="app-onboarding__head">
          <h2 className="app-onboarding__title">Запуск обучения для команды</h2>
          <span className="app-onboarding__progress">
            {doneCount}/{STEPS.length}
          </span>
        </div>
        <p className="app-onboarding__channel">
          Мессенджер: <strong>{messengerLabel}</strong>{" "}
          <Link to="/main/profile" className="app-onboarding__link">
            Изменить
          </Link>
        </p>
      <ol className="app-onboarding__list">
        {STEPS.map((step, index) => {
          const isDone = completed[step.id];
          const Icon = isDone
            ? CheckCircleOutlineIcon
            : RadioButtonUncheckedIcon;

          return (
            <li
              key={step.id}
              className={`app-onboarding__item${
                isDone ? " app-onboarding__item--done" : ""
              }`}
            >
              <Icon className="app-onboarding__icon" fontSize="small" />
              <div className="app-onboarding__content">
                <strong>
                  Шаг {index + 1}. {step.title}
                </strong>
                <p>{step.desc}</p>
                {step.link && !isDone ? (
                  <Link to={step.link} className="app-onboarding__link">
                    {step.linkLabel}
                  </Link>
                ) : null}
              </div>
            </li>
          );
        })}
      </ol>
    </section>
  );
}
